import apiInvitado from "../api/Invitado/api-invitado";

const ValidateTokenExistence = async (config: any, token: string) => {
    // Si no existe el token, se genera un token invitado, se almacena en el localStorage y se configura el header con dicho token
    let tokenInvitado: any;

    if (!token) {
        const newTokenInvitado = await apiInvitado.tokenInvitado();
        tokenInvitado = newTokenInvitado.token;
        localStorage.setItem("token", tokenInvitado)
        config.headers.Authorization = `${tokenInvitado}`
    } else {
        // En caso de que el token exista se envía por la cabecera
        const responseValidateToken = await apiInvitado.validateToken(token);
        tokenInvitado = token;

        if (responseValidateToken.status !== 200) {
            const newTokenInvitado = await apiInvitado.tokenInvitado();
            tokenInvitado = newTokenInvitado.token;
            localStorage.setItem("token", tokenInvitado)
        }

        config.headers.Authorization = `${tokenInvitado}`
    }
}

export default ValidateTokenExistence